import React from 'react';
import { motion } from 'framer-motion';
interface BonusCardProps {
  title: string;
  description: string;
  imageSrc?: string;
  emoji?: string;
  number: number;
}
export function BonusCard({
  title,
  description,
  imageSrc,
  emoji,
  number
}: BonusCardProps) {
  const checkoutUrl = 'https://checkout.solucionstore.shop/cart/45164104384703:1';
  return <motion.a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="block bg-white border-2 border-dashed border-yellow-500 rounded-xl overflow-hidden hover:shadow-xl transition-shadow duration-300 h-full flex flex-col" whileHover={{
    y: -5
  }} data-id="element-17">
      <div className="bg-yellow-500 text-white font-bold text-center py-1 text-sm uppercase tracking-wider" data-id="element-18">
        GRATIS HOY
      </div>

      {imageSrc ? <div className="w-full relative overflow-hidden bg-gray-100" data-id="element-19">
          <img src={imageSrc} alt={title} className="w-full h-auto object-contain" data-id="element-20" />
        </div> : <div className="aspect-[3/2] w-full bg-yellow-50 flex items-center justify-center text-6xl" data-id="element-21">
          {emoji}
        </div>}

      <div className="p-5 flex-1 flex flex-col" data-id="element-22">
        <div className="text-yellow-600 font-bold text-xs mb-1 uppercase tracking-wide" data-id="element-23">
          Bono #{number}
        </div>
        <h3 className="text-xl font-bold text-gray-900 mb-2 leading-tight" data-id="element-24">
          {title}
        </h3>
        <p className="text-gray-600 text-sm leading-relaxed flex-1" data-id="element-25">
          {description}
        </p>
        <div className="mt-4 pt-4 border-t border-gray-100 text-center" data-id="element-26">
          <span className="text-red-500 font-bold line-through text-sm mr-2" data-id="element-27">
            $39.990
          </span>
          <span className="text-green-600 font-bold text-lg" data-id="element-28">GRATIS</span>
        </div>
      </div>
    </motion.a>;
}